import { Pencil, Trash2 } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../hooks/useStore';
import type { IHospitalRecordResult } from '../../../../models/hospital/HospitalModel';
import styles from '../HospitalFiles.module.css';

export type HospitalFilesActionCellProps = {
  row: IHospitalRecordResult;
};

const HospitalFilesActionCell = ({ row }: HospitalFilesActionCellProps) => {
  const { popupStore, hospitalFilesStore } = useStore();

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    hospitalFilesStore.setSelectedRecord(row);
    popupStore.setIsEditManuelRowOpen(true);
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (row.id) {
      hospitalFilesStore.setRecordToDelete(row);
      popupStore.setIsDeleteConfirmationOpen(true);
    }
  };

  return (
    <div className={styles.actionCell}>
      <button onClick={handleEdit} className={styles.editButton} title="Düzenle">
        <Pencil size={16} strokeWidth={2} />
      </button>
      <button onClick={handleDelete} className={styles.deleteButton} title="Sil">
        <Trash2 size={16} strokeWidth={2} />
      </button>
    </div>
  );
};

export default observer(HospitalFilesActionCell);
